// This file is generated by a script. Do not edit this file directly.
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from 'react';
export var CaretRight = function CaretRight(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 20 20"
  }, props), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M13.676 10.88a1.25 1.25 0 0 0 0-1.769l-5-5a1.245 1.245 0 0 0-1.364-.27 1.25 1.25 0 0 0-.773 1.157l.004 10a1.255 1.255 0 0 0 2.137.886l5-5z"
  }));
};
